import { useContext } from 'react';
import { Button, Col, Row, Table, Tag } from 'antd';
import {
    AuditOutlined,
    CalendarOutlined,
    CheckCircleOutlined,
    CloudUploadOutlined,
    FileTextOutlined,
    TagOutlined,
} from '@ant-design/icons';

import useCityTaxesAuto from './useCityTaxesAuto';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import KpiCard from '../../components/KpiCard';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function CityTaxesAuto() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        columns,
        tableData,
        stats,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        handleClickImportCityTaxAuto,
        navigate,
    } = useCityTaxesAuto();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<AuditOutlined />}
                title="Impostos (IPTU)"
                tag={<Tag color="blue">{poeValorComPontosEmMil(stats.total)} cadastrados</Tag>}
                subtitle="Gerencie, visualize e acompanhe todos os lançamentos e arrecadações de tributos municipais"
                actions={
                    <Button
                        type="primary"
                        icon={<CloudUploadOutlined />}
                        onClick={handleClickImportCityTaxAuto}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Importar Impostos
                    </Button>
                }
            />

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<FileTextOutlined />}
                        title="Total de Lançamentos"
                        value={poeValorComPontosEmMil(stats.total)}
                        accentColor="#1677ff"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CheckCircleOutlined />}
                        title="Impostos IPTU"
                        value={poeValorComPontosEmMil(stats.iptu)}
                        accentColor="#52c41a"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<TagOutlined />}
                        title="Cota Única"
                        value={poeValorComPontosEmMil(stats.cotaUnica)}
                        accentColor="#722ed1"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CalendarOutlined />}
                        title="Parcelados"
                        value={poeValorComPontosEmMil(stats.parcelado)}
                        accentColor="#fa8c16"
                    />
                </Col>
            </Row>

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação para ver os detalhes do usuário." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="impostos"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        position: [],
                    }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            if (record.app_user?.id) {
                                navigate(`/usuarios/auto/${record.app_user.id}`);
                            }
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="impostos"
                pageSizeOptions={['10', '25', '50', '100', '200']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
